/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  CreateAPIKeyForUserOptions,
  CreateAPIKeyForUserResponses,
} from '../types/CreateAPIKeyForUser'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Create apikey for a user
 * {@link /v1/user/apikey}
 */
export function createAPIKeyForUser<ThrowOnError extends boolean = true>(
  options: Options<CreateAPIKeyForUserOptions, ThrowOnError>,
): Unwrappable<RequestResult<CreateAPIKeyForUserResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/user/apikey',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<CreateAPIKeyForUserResponses, ThrowOnError>>,
  )
}
